<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Productos</h1>
        </div>
        <div class="ctn_general">
            <!-- Aquí el contenido -->
            <div class="tabla_ctn">
                <div class="tabla_filtros">
                    <Filters :data="filterData" label="Filtrar productos" @onFilter="onFilter"/>
                    <div class="tfiltros_col xs right mOrder1 nowrap">
                        <a @click="downloadExcel" href="javascript:void(0)"
                           class="descargar_archivo mdi mdi-arrow-collapse-down tool mobileOrder1">
                            <span class="tooltip top left">Descargar Excel</span>
                        </a>
                        <div class="mdi mdi-magnify input_search mobileOrder3">
                            <form @submit.prevent="search">
                                <input type="search" placeholder="Buscar por descripción, categoría o subcategoría"
                                       v-model="keyword">
                            </form>
                        </div>
                        <form action="" class="mobileOrder2">
                            <router-link tag="a" class="btn" :to="{name:'product-creator'}">Agregar producto
                            </router-link>
                        </form>
                    </div>
                </div>

                <div class="tabla_scroll">
                    <table class="lProducto con_options">
                        <thead>
                        <tr>
                            <th>Imagen</th>
                            <th>ID</th>
                            <th>Descripción</th>
                            <th>Categoría</th>
                            <th>Subcategoría</th>
                            <th>Precio</th>
                            <th>Stock</th>
                            <th>Cant. max.</th>
                            <th>Cant. base</th>
                            <th>Estado</th>
                            <th class="d_option"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="p in products">
                            <td style="text-align: center;"><img class="click_img" :src="p.imageUrl" alt=""></td>
                            <td>{{p.id}}</td>
                            <td>{{p.description}}</td>
                            <td>{{p.category}}</td>
                            <td>{{p.subcategory}}</td>
                            <td v-pen="p.price" style="text-align: right;"></td>
                            <td style="text-align: right;">{{p.stock}}</td>
                            <td style="text-align: right;">{{p.qtyMax}}</td>
                            <td style="text-align: right;">{{p.qtyBase}}</td>
                            <td style="text-align: right;"><span :class="`budget ${getStatusStr(p.status).color}`">{{getStatusStr(p.status).value}}</span>
                            </td>
                            <td class="d_option">
                                <i class="mdi mdi-dots-vertical"></i>
                                <span class="drop_options estados_pedido">
									<span @click="edit(p)">Editar producto</span>
                                    <span @click="uploadImage(p)">Subir imagen</span>
								</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Paginator :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
                           :changePageSize="changePageSize"/>
            </div>
        </div>
        <div class="lightbox">
            <div class="lightbox_overlay"></div>
            <div class="lightbox_ctn">
                <img class="lightbox_img" src="">
                <div class="lightbox_cerrar">
                    <div class="mdi mdi-close"></div>
                </div>
            </div>
        </div>

        <ProductImageUpload :product-in="selectedProduct" @updated="onUpdated" @closed="onClosed"/>
    </div>
</template>
<script>

    import ProductService from "../../services/ProductService";
    import CategoryService from "../../services/CategoryService";
    import {productStatuses} from '../../util/options'
    import Paginator from '../common/Paginator.vue'
    import {getFileName, loading} from '../../util/util'
    import fileDownload from 'js-file-download';
    import {paginatorMixin} from '../../util/paginatorMixin'
    import Filters from '../common/Filters.vue'
    import ProductImageUpload from './ProductImageUpload'

    export default {
        components: {
            Paginator,
            ProductImageUpload,
            Filters
        },
        data() {
            return {
                products: [],
                selectedProduct: null,
                keyword: null,
                filters: [],
                filterData: []
            }
        },
        mixins: [paginatorMixin],
        computed: {},
        methods: {
            getStatusStr(status) {
                return productStatuses.find((s) => s.key === status);
            },
            changePage(p) {
                const self = this;
                self.page = p;
                self.listProducts(p, self.pageSize)
            },
            changePageSize(pageSize) {
                const self = this;
                this.page = 1;
                this.pageSize = pageSize;
                self.listProducts(1, pageSize)
            },
            downloadExcel() {
                loading(true);
                const params = {};
                const self = this;
                if (self.keyword)
                    params.keyword = self.keyword;

                if (self.filters && self.filters.length > 0) {
                    self.filters.forEach(it => {
                        let opts;
                        if (it.data instanceof Array) {
                            opts = [];
                            it.data.forEach(o => {
                                opts.push(o.key);
                            })
                        } else {
                            opts = it.data.key;
                        }
                        params[it.key] = opts;
                    })
                }

                ProductService.downloadExcel(params).then(response => {
                    fileDownload(response.data, getFileName(response));
                }).catch((err) => {
                    console.error(err);
                    alert.error("Error al descargar lista de productos");
                }).finally(() => {
                    loading(false);
                });
            },
            async listProducts(page, pageSize) {
                loading(true);
                const self = this;
                const params = {page: page - 1., size: pageSize};
                if (self.keyword)
                    params.keyword = self.keyword;

                if (self.filters && self.filters.length > 0) {
                    self.filters.forEach(it => {
                        let opts;
                        if (it.data instanceof Array) {
                            opts = [];
                            it.data.forEach(o => {
                                opts.push(o.key);
                            })
                        } else {
                            opts = it.data.key;
                        }
                        params[it.key] = opts;
                    })
                }

                const resp = (await ProductService.list(params)).data.payload;
                self.products = resp.content;
                self.total = resp.totalElements;
                self.pages = resp.totalPages;
                loading(false);
            },
            search() {
                const self = this;
                self.page = 1;
                self.listProducts(self.page, self.pageSize);
            },
            uploadImage(prod) {
                this.selectedProduct = prod;
                $(".modal-product-image-upload").addClass("active");
            },
            edit(prod) {
                this.$router.push({name: 'product-editor', params: {productId: prod.id}});
            },
            onUpdated(prod) {
                const self = this;
                const prodFiltered = self.products.find((p) => {
                    return p.id === prod.id;
                });
                self.selectedProduct = null;
                if (prodFiltered) {
                    const index = self.products.indexOf(prodFiltered);
                    self.$set(self.products, index, prod);
                }
            },
            onClosed() {
                this.selectedProduct = null;
            },
            onFilter(data) {
                const self = this;
                self.filters = data;
                self.page = 1;
                self.listProducts(self.page, self.pageSize);

            },
        },
        async mounted() {
            const self = this;
            self.filterData = [];
            self.listProducts(this.page, this.pageSize);

            const categories = [];
            const subcategories = [];
            const response = (await CategoryService.list()).data.payload;
            const sortedCategories = response.sort((a, b) => (a.desc > b.desc) ? 1 : -1);
            sortedCategories.forEach((i) => {
                if (!i.parentKey)
                    categories.push({key: i.key, value: i.desc});
                else
                    subcategories.push({key: i.key, value: i.desc});
            });

            self.filterData.push({key: 'category', label: 'Categoría', type: 'multiple', items: categories});
            self.filterData.push({
                key: 'subcategory',
                label: 'Sub-Categoría',
                type: 'multiple',
                items: subcategories
            });
            self.filterData.push({
                key: 'stock',
                label: 'Con stock',
                type: 'single',
                items: [{key: 1, value: 'Sí'}, {key: 0, value: 'No'}]
            });
            self.filterData.push({key: 'status', label: 'Estado', type: 'single', items: productStatuses});
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/products/Products.vue